
const USER_KEY = '__user__'

export function saveUser(query){
	let val = query.expired || 1000 * 60 * 60 * 24 * 30; //一个月; 1天 //1000 * 60 * 60 * 24
	query.expired = new Date().getTime() + val;
	localStorage.setItem(USER_KEY, JSON.stringify(query));
	return query
}

export function getUser(){
	let val = JSON.parse(localStorage.getItem(USER_KEY));
	if(!val){return}
	let nowTime = new Date().getTime();
	let oldTime = val.expired;
	if(nowTime > oldTime){
		clearUser()
		return
	}
	return val
}

export function clearUser(){
	localStorage.removeItem(USER_KEY);
	return undefined
}


const COLLEGE_KEY = '__college__'

export function saveCollege(query){
	let val = query.expired || 1000 * 60 * 60 * 12; //12h; 1天 //1000 * 60 * 60 * 24
	query.expired = new Date().getTime() + val;
	localStorage.setItem(COLLEGE_KEY, JSON.stringify(query));
	return query
}

export function getCollege(){
	//return JSON.parse(localStorage.getItem(COLLEGE_KEY));	 
	let val = JSON.parse(localStorage.getItem(COLLEGE_KEY));
	if(!val){return}
	let nowTime = new Date().getTime();
	let oldTime = val.expired;
	if(nowTime > oldTime){
		clearUser()
		return
	}
	return val

}

export function clearCollege(){
	localStorage.removeItem(COLLEGE_KEY);
	return undefined
}


// WEBPACK FOOTER //
// ./src/common/js/cache.js